import * as React from 'react';
import { BodyCell } from '@tableau/widgets-datagrid';
import { StyledCellFormatter } from '../StyledCellWrapper';
import { ISubscriptionInfo } from '../../../../ts/models/ISubscriptionInfo';
import { CreateCellText } from './PlainTextAndNumberCells';
import { Messages } from '../../../../codegen/Localize';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { DateTimeCell, OverridableDateTimeCell } from './DateTimeCells';

export function SubscriptionNextUpdateDescriptionCell(): React.StatelessComponent<BodyCell.Props> {
  return StyledCellFormatter(
      function SubscriptionNextUpdateDescriptionCell(props: BodyCell.Props) {
        const row = props.row;
        const subscription = row.data as ISubscriptionInfo;
        if (subscription.refreshExtractTriggered != null
            && subscription.refreshExtractTriggered) {
          return CreateCellText(Messages.subscriptionOnExtractRefreshNextUpdate());
        } else if (FeatureFlags.suspendSubscriptions) {
          return OverridableDateTimeCell('runNextAt', 'suspended', Messages.disabled())(props);
        } else {
          return DateTimeCell('runNextAt', Messages.disabled())(props);
        }
      }
  );
}
